// components

// react
import { useEffect, useState } from 'react';
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from '@progress/kendo-ui';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox } from '@progress/kendo-react-inputs';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Input, TextArea } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';

// css
import "./add_mobile.css";
import styles from "./add_mobile.module.css";

// services
import { getRgns, getDongs } from './../../../service/areaService';
import { getUser, isAdmin, isLogin, isDeveloper } from '../../../service/authService';
import { setUserInsert } from '../../../service/mngt/elderService';
import { checkDuplicatedCid, checkDuplicatedId } from '../../../service/mngt/managerService';

// com
import { parseDate } from '../../../com/dateUtil';
import DatePickerKo from '../../com/dateInputs/datePickerKo';
import DateTimePickerKo from '../../com/dateInputs/dateTimePickerKo';

function AddMobile({conn}) {

  const userInfo = getUser();
  const { kakao } = window;
  
  const bizTypeList = [
    {bizType: "5001", bizTypeTerm: "1차 검은색 장비"},
    {bizType: "5002", bizTypeTerm: "2차 흰색 장비"},
    {bizType: "5003", bizTypeTerm: "3차 안심박스"},
  ]

  const genderList = ['M', 'W'];

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };


  const [loading, setLoading] = useState(false);

  // DIALOG 설정
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const [addDialogVisible, setAddDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("대상자를 추가하시겠습니까?");
  const closeCompleteDialog = () => {
    setCompleteDialogVisible(false);
  }

  // 데이터 상태 관리
  const [data, setData] = useState({
    userId: '',
    userIdCheck: false,
    userTerm: '',
    userTypeCode: 2001,
    meainStatCode: null,
    cid: '',
    cidCheck: false,
    bizType: '',
    bizTypeData: { bizType: '', bizTypeTerm: '장비구분 선택' },
    imei: '',
    birthday: kendo.toString(new Date(), 'yyyy-MM-dd'),
    userGender: '',
    address: '',
    userPhone: '',
    managerId: '',
    managerTerm: '',
    protectorTerm: '',
    protectorPhone: '',
    installDtm: parseDate('yyyy-mm-dd hh:mm:ss', new Date()),
    liveType: '',
    sickType: '',
    note: '',
    notePickYn: 'N',
    streetAddress: '',
    lat: '',
    lng: '',
    dangerYn: 'N',
    absenceYn: 'N',
    locationYn: 'N',

    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
  });

  // 데이터 저장
  const [dataSource, setDataSource] = useState({
    rgnList: [], 
    dongList: [],
  });

  // 위경도 조회
  const [address, setAddress] = useState({ value: ''});
  const [lat, setLat] = useState({ value: '' });
  const [lng, setLng] = useState({ value: '' });
  const [latLngBoolean, setLatLngBoolean] = useState(false);
  

  // ID onChange
  const handleIdChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.userId = e.target.value;
      item.userIdCheck = false;
      return item;
    })
  }

  // ID 중복확인 버튼 클릭 이벤트
  const duplIdCheck = e => {
    e.preventDefault();
    checkDuplicatedId(conn, data.userId)
      .then(response => {
        if (response) {
          setDialogMessage("중복된 ID입니다. 다른 ID를 입력해 주시기 바랍니다.");
          setCompleteDialogVisible(true);
          setData({ ...data, userIdCheck: false });
        } else {
          if (data.userId) {
            setDialogMessage("사용가능한 ID입니다.");
            setCompleteDialogVisible(true);
            setData({ ...data, userIdCheck: true });
          } else {
            setDialogMessage("ID를 입력해 주세요.");
            setCompleteDialogVisible(true);
            setData({ ...data, userIdCheck: false });
          }
        }
      })
      .catch(error => {
        setDialogMessage("ID를 올바르게 입력해 주세요.");
        setCompleteDialogVisible(true);
        setData({ ...data, userIdCheck: false });
      });
  };

  // 대상자성함 onChange
  const handleUserTermChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.userTerm = e.target.value;
      return item;
    })
  }

  
  // CID onChange
  const handleCidChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.cid = e.target.value;
      item.cidCheck = false;
      return item;
    })
  }
  
  // CID 중복확인 버튼 클릭 이벤트
  const duplCidCheck = e => {
    e.preventDefault();
    checkDuplicatedCid(conn, data.cid)
      .then(response => {
        if (response) {
          setDialogMessage("중복된 CID입니다. CID를 확인 후 다시 입력해 주시기 바랍니다.");
          setCompleteDialogVisible(true);
          setData({ ...data, cidCheck: false });
        } else {
          if (data.cid) {
            setDialogMessage("사용가능한 CID입니다.");
            setCompleteDialogVisible(true);
            setData({ ...data, cidCheck: true });
          } else {
            setDialogMessage("기기 CID를 입력해 주세요.");
            setCompleteDialogVisible(true);
            setData({ ...data, cidCheck: false });
          }
        }
      })
      .catch(error => {
        console.log("checkDuplicatedCid error", error);
        setDialogMessage("CID를 올바르게 입력해 주세요.");
        setCompleteDialogVisible(true);
        setData({ ...data, cidCheck: false });
      });
  };

  // 장비구분 onChange
  const handleBizTypeChange = (e) => {
    setData(data => {
      const item = { ...data };
      item.bizType = e.value.bizType;
      item.bizTypeData = { bizType: e.value.bizType, bizTypeTerm: e.value.bizTypeTerm };
      return item;
    });
  }

  // IMEI onChange
  const handleImeiChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.imei = e.target.value;
      return item;
    })
  }

  // 대상자성별 onChange
  const handleGenderChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.userGender = e.target.value;
      return item;
    })
  }

  // 시군구, 읍면동 onChange
  const handleAreaChange = e => {
    if (e.target.name === "rgn") {
      setData(data => {
        const item = { ...data };
        // 드롭다운 검색조건 변경
        item.rgnCode = e.target.value.rgnCode;
        item.rgns = e.target.value;
        // 하위 데이터 초기화
        item.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
        item.dongCode = "";
        return item;
      })
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode)
      .then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      })
      .catch(error => {
        console.log("getDongs error = ", error);
      });

    } else if (e.target.name === "dong") {
      setData(data => {
        const item = { ...data };
        // 드롭다운 검색조건 변경
        item.dongCode = e.target.value.dongCode;
        item.dongs = e.target.value;
        return item;
      })
    }
  }

  // 상세주소 onChange
  const handleAddressChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.address = e.target.value;
      return item;
    })
  }  

  // 대상자연락처 onChange
  const handlePhoneChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.userPhone = e.target.value;
      return item;
    })
  }

  // 담당자 onChange
  const handleManagerChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.managerId = e.target.value;
      return item;
    })
  }  

  // 보호자성함 onChange
  const handleProtectorTermChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.protectorTerm = e.target.value;
      return item;
    })
  }

  // 보호자연락처 onChange
  const handleProtectorPhoneChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.protectorPhone = e.target.value;
      return item;
    })
  }

  // 거주유형 onChange
  const handleLiveTypeChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.liveType = e.target.value;
      return item;
    })
  }

  // 보유지병 onChange
  const handleSickTypeChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.sickType = e.target.value;
      return item;
    })
  }

  // 특이사항 onChange
  const handleNoteChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.note = e.target.value;
      return item;
    })
  }

  // 도로명주소 onChange
  const handleLatLngChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.streetAddress = e.target.value;
      return item;
    })
    // data.streetAddress = e.target.value;
  }

  // 위경도 조회 onClick
  const searchLatLng = (e) => {
    // e.preventDefault();
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(data.streetAddress, (result, status) => {
      if(result.length === 0) {
        setDialogMessage("도로명 주소가 올바르지 않습니다.");
        setCompleteDialogVisible(true);
      }
      if (status === kakao.maps.services.Status.OK) {
        // setAllowSubmit(true);
        const resultLat = result[0].y;
        const resultLng = result[0].x;
        
        setData((data) => {
          const item = { ...data };
          item.lat = resultLat;
          item.lng = resultLng;
          return item;
        })

      }
    });
  }

  // 위도 onChange
  const handleLatChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.lat = e.target.value;
      return item;
    })
  }

  // 경도 onChange
  const handleLngChange = (e) => {
    setData((data) => {
      const item = { ...data };
      item.lng = e.target.value;
      return item;
    })
  }

  // 위험대상자 onChange
  const handleDangerYnChange = (e) => {
    if(e.value) {
      setData((data) => {
        const item = { ...data };
        item.dangerYn = 'Y';
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.dangerYn = 'N';
        return item;
      })
    }
  }

  // 장기부재 onChange
  const handleAbsenceYnChange = (e) => {
    if(e.value) {
      setData((data) => {
        const item = { ...data };
        item.absenceYn = 'Y';
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.absenceYn = 'N';
        return item;
      })
    }
  }

  // 위치추적 onChange
  const handleLocationYnChange = (e) => {
    if(e.value) {
      setData((data) => {
        const item = { ...data };
        item.locationYn = 'Y';
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.locationYn = 'N';
        return item;
      })
    }
  }

  // 설치예정자 onChange
  const handleUserTypeChange = (e) => {
    if(e.value) {
      setData((data) => {
        const item = { ...data };
        item.meainStatCode = 20005;
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.meainStatCode = null;
        return item;
      })
    }
  }

  // 대상자 추가 onClick
  const handleSubmit = (e) => {
    e.preventDefault(); // 기본 동작 방지

    if(!data.userTerm) {
      setDialogMessage("대상자 성함을 입력해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.bizType) {
      setDialogMessage("장비구분을 선택해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(data.bizType === '5003' && !data.imei) {
      setDialogMessage("IMEI를 입력해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.userGender) {
      setDialogMessage("대상자 성별을 선택해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.rgnCode) {
      setDialogMessage("시군구를 선택해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.dongCode) {
      setDialogMessage("읍면동을 선택해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.address) {
      setDialogMessage("상세주소를 입력해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.userPhone) {
      setDialogMessage("연락처를 입력해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.managerId) {
      setDialogMessage("담당자 ID를 입력해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    if(!data.lat || !data.lng) {
      setDialogMessage("위도와 경도를 입력해 주세요.");
      setCompleteDialogVisible(true);
      return;
    }

    setDialogMessage("대상자를 추가하시겠습니까?");
    setAddDialogVisible(true);
  }

  // 대상자 추가 확인
  const saveAddDialog = () => {
    setUserInsert(conn, data)
    .then(response => {
      setDialogMessage("대상자가 추가되었습니다.");
      setCompleteDialogVisible(true);
      setData((data) => {
        const item = { ...data };
        item.userId = ''
        item.userTerm = '';
        item.cid = '';
        item.bizType = '';
        item.bizTypeData = { bizType: '', bizTypeTerm: '장비구분 선택' };
        item.imei = '';
        item.birthday = kendo.toString(new Date(), 'yyyy-MM-dd');
        item.userGender = '';
        item.rgnCode = '';
        item.dongCode = '';
        item.address = '';
        item.userPhone = '';
        item.managerId = '';
        item.managerTerm = '';
        item.protectorTerm = '';
        item.protectorPhone = '';
        item.installDtm = parseDate('yyyy-mm-dd hh:mm:ss', new Date());
        item.liveType = '';
        item.sickType = '';
        item.note = '';
        item.streetAddress = '';
        item.lat = '';
        item.lng = '';
        item.dangerYn = 'N';
        item.absenceYn = 'N';
        item.locationYn = 'N';
        item.meainStatCode = null;
        return item;
      })
      //   window.location.replace('/add');
    })
    .catch(error => {
      console.log("setUserInsert error = ", error);
    })
    setAddDialogVisible(false);
  }
  // 대상자 추가 취소
  const closeAddDialog = () => {
    setAddDialogVisible(false);
  }
  // 초기 지역 데이터 가져오기
  const getDataList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setData(data => {
        const item = { ...data };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setData(data => {
        const item = { ...data };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });

  }

  useEffect(() => {
    getDataList();
  }, [])

  return (
    <>
      <div className="pageContent_m">
        <div className={styles.addForm}>
          <div className={styles.info}>
            <label className={styles.label}>ID</label>
            <input className={styles.contentAddress} style={!data.userId ? {border: "1px solid red"} : {}} value={data.userId} onChange={handleIdChange} placeholder="중복 여부를 확인해 주세요."></input>
            <button className={styles.contentAddressButton} onClick={duplIdCheck}>중복</button>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>대상자 성함</label>
            <input className={styles.content} style={!data.userTerm ? {border: "1px solid red"} : {}} value={data.userTerm} onChange={handleUserTermChange} required></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>CID</label>
            <input className={styles.contentAddress} style={!data.cid ? {border: "1px solid red"} : {}} value={data.cid} onChange={handleCidChange} placeholder="중복 여부를 확인해 주세요."></input>
            <button className={styles.contentAddressButton} onClick={duplCidCheck}>중복</button>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>장비구분</label>
            <DropDownList
              className={styles.dropdown}
              data={bizTypeList}
              required={true}
              textField="bizTypeTerm"
              dataItemKey="bizType"
              value={data.bizTypeData}
              defaultItem={{ bizType: '', bizTypeTerm: '장비구분 선택' }}
              validationMessage={'장비구분을 선택 해주세요.'}
              onChange={handleBizTypeChange}
            />
          </div>
          {data.bizType === '5003' && (
            <div className={styles.info}>
              <label className={styles.label}>IMEI</label>
              <input className={styles.content} style={!data.imei ? {border: "1px solid red"} : {}} onChange={handleImeiChange}></input>
            </div>
          )}
          <div className={styles.info}>
            <label className={styles.label}>생년월일</label>
            <div className="datepickerDiv">
              <DatePickerKo
                format="yyyy.MM.dd"
                value={new Date(data.birthday)}
                setDtm={v => {
                  setData((data) => {
                    const item = { ...data };
                    item.birthday = kendo.toString(v, 'yyyy-MM-dd');
                    return item;
                  })
                }}
              />
            </div>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>성별</label>
            <DropDownList
              className={styles.dropdown}
              data={genderList}
              defaultItem={'성별 선택'}
              // value={formRenderProps.value}
              validationMessage={'성별을 선택 해주세요.'}
              onChange={handleGenderChange}
            />
          </div>
          <div className={styles.info}>
            <label className={styles.label}>시군구</label>
            <DropDownList
              className={styles.dropdown}
              id="rgn"
              name="rgn"
              data={dataSource.rgnList}
              disabled={!isDeveloper() ? true : false}
              value={data.rgns}
              textField="rgnTermSimple"
              dataItemKey="rgnCode"
              defaultItem={defualtValRgn}
              onChange={handleAreaChange}
              popupSettings={{ width: '210px' }}
              required={true}
              validationMessage={'담당 시군구를 선택 해주세요.'}
            />
          </div>
          <div className={styles.info}>
            <label className={styles.label}>읍면동</label>
            <DropDownList
              className={styles.dropdown}
              id="dong"
              name="dong"
              data={dataSource.dongList}
              disabled={!isAdmin() ? true : !data.rgnCode ? true : false}
              value={data.dongs}
              textField="dongTermSimple"
              dataItemKey="dongCode"
              defaultItem={defualtValDong}
              onChange={handleAreaChange}
              popupSettings={{ width: '210px' }}
              required={true}
              validationMessage={'담당 읍면동을 선택 해주세요.'}
            />
          </div>
          <div className={styles.info}>
            <label className={styles.label}>상세주소</label>
            <input className={styles.content} style={!data.address ? {border: "1px solid red"} : {}} value={data.address} onChange={handleAddressChange}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>연락처</label>
            <input className={styles.content} style={!data.userPhone ? {border: "1px solid red"} : {}} value={data.userPhone} onChange={handlePhoneChange} placeholder="번호만 입력해 주세요." minLength={10} maxLength={11}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>담당자 ID</label>
            <input className={styles.content} style={!data.managerId ? {border: "1px solid red"} : {}} value={data.managerId} onChange={handleManagerChange}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>보호자 성함</label>
            <input className={styles.content} value={data.protectorTerm} onChange={handleProtectorTermChange}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>보호자 연락처</label>
            <input className={styles.content} value={data.protectorPhone} onChange={handleProtectorPhoneChange} placeholder="번호만 입력해 주세요." minLength={10} maxLength={11}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>설치일시</label>
            <div className="datepickerDiv">
              <DateTimePickerKo
                value={new Date(data.installDtm)}
                setDtm={v => {
                  setData((data) => {
                    const item = { ...data };
                    item.installDtm = parseDate('yyyy-mm-dd hh:mm:ss', v);
                    return item;
                  })
                }}
              />
            </div>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>거주유형</label>
            <input className={styles.content} value={data.liveType} onChange={handleLiveTypeChange}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>보유지병</label>
            <input className={styles.content} value={data.sickType} onChange={handleSickTypeChange}></input>
          </div>
          <div className={styles.info} style={{height: "10vh"}}>
            <label className={styles.label}>특이사항</label>
            <textarea className={styles.contentTextarea} value={data.note} onChange={handleNoteChange}></textarea>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>도로명주소<br/>(위경도조회)</label>
            <input className={styles.contentAddress} type="text" value={data.streetAddress} onChange={handleLatLngChange}></input>
            <button className={styles.contentAddressButton} onClick={searchLatLng}>조회</button>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>위도</label>
            <input className={styles.content} type="number" style={!data.lat ? {border: "1px solid red"} : {}} value={data.lat} onChange={handleLatChange}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>경도</label>
            <input className={styles.content} type="number" style={!data.lng ? {border: "1px solid red"} : {}} value={data.lng} onChange={handleLngChange}></input>
          </div>
          <div className={styles.info}>
            <label className={styles.label}>관리대상자</label>
            <Checkbox
              className="check"
              checked={data.dangerYn === 'Y'}
              // checked={formRenderProps.value === 'Y'} 
              onChange={handleDangerYnChange}
              label={'체크 시 관리 대상자로 전환'} 
            />
          </div>
          <div className={styles.info}>
            <label className={styles.label}>장기부재</label>
            <Checkbox
              className="check"
              checked={data.absenceYn === 'Y'}
              // checked={formRenderProps.value === 'Y'} 
              onChange={handleAbsenceYnChange}
              label={'체크 시 위험 상태로 전환되지 않음'} 
            />
          </div>
          <div className={styles.info}>
            <label className={styles.label}>위치추적</label>
            <Checkbox
              className="check"
              checked={data.locationYn === 'Y'}
              // checked={formRenderProps.value === 'Y'} 
              onChange={handleLocationYnChange}
              label={'체크 시 위치추적 대상자로 전환'} 
            />
          </div>
          <div className={styles.info}>
            <label className={styles.label}>설치예정자</label>
            <Checkbox
              className="check"
              checked={data.meainStatCode !== null}
              // checked={formRenderProps.value === 'Y'} 
              onChange={handleUserTypeChange}
              label={'체크 시 설치예정 대상자로 전환'} 
            />
          </div>
          <div className={styles.info}>
            <Button className={styles.addButton} onClick={handleSubmit} disabled={!data.userIdCheck || !data.cidCheck}>대상자 추가</Button>
          </div>
        </div>
      </div>
      {completeDialogVisible && (
          <Dialog
            className="completeDialog"
            width={"90vw"}
            height={"40vw"}
            closeIcon={false}
          >
            <p>
              {dialogMessage}
              <br></br>
              <button onClick={closeCompleteDialog}>확인</button>
            </p>
          </Dialog>
        )}
      {addDialogVisible && (
          <Dialog
            className="completeDialog"
            width={"90vw"}
            height={"40vw"}
            closeIcon={false}
          >
            <p>
              {dialogMessage}
              <br></br>
              <button onClick={saveAddDialog}>확인</button>
              <button style={{ color: "black", background: "#dddddd", marginLeft: "2vw"}} onClick={closeAddDialog}>취소</button>
            </p>
          </Dialog>
        )}
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
    </>
  );
}

export default AddMobile;
